module.exports = __webpack_public_path__ + "img/media_2.6e030062.jpg";